import * as React from 'react'

import { Box, Text } from '@factorialco/deprecated-design-system'
import { AvailableModules, Features } from 'generated/featureDefinitions'

import { observer } from 'mobx-react'

import Upgrade from 'modules/core/components/Upgrade'
import { UpgradeActions } from 'modules/core/components/Upgrade'
import i18n from 'modules/core/lib/i18n'

import subscriptions from 'modules/billing/store/collections/subscriptions'
import RequestUpgradeModal from 'modules/upsell/components/RequestUpgradeModal'
import { ValidReasons } from 'modules/upsell/hooks/useCreateUpsellRequest'

const UpgradePlan = () => {
  const [showUpgradeModalFlow, setShowUpgradeModalFlow] = React.useState(false)
  const subscription = subscriptions.current

  return (
    <>
      <Box flexGrow paddingX="s0" paddingBottom="s32" width="full">
        <Upgrade.Small
          title={i18n.t('settings.approvals.approval_rule.upgrade_plan.title')}
          action={{
            type: UpgradeActions.knowMore,
            onClick: () => {
              setShowUpgradeModalFlow(true)
            },
          }}
        />
        {showUpgradeModalFlow && (
          <RequestUpgradeModal
            moduleRequested={AvailableModules.expenses}
            featureRequested={Features.expenses_auto_approval_rules}
            requestSource="Approval flow configuration"
            requestReason={
              subscription.isLegacy
                ? ValidReasons.MissingFeatureLegacy
                : ValidReasons.MissingFeature
            }
            title={i18n.t('settings.approvals.approval_rule.upgrade_plan.modal_title')}
            description={
              <Box gap="s16">
                <Text.Normal size="300" overflowWrap>
                  {i18n.t('settings.approvals.approval_rule.upgrade_plan.modal_description')}
                </Text.Normal>
                <Text.Normal size="300" overflowWrap>
                  {i18n.t('settings.approvals.approval_rule.upgrade_plan.modal_upgrade')}
                </Text.Normal>
              </Box>
            }
            onClose={() => {
              setShowUpgradeModalFlow(false)
            }}
          />
        )}
      </Box>
    </>
  )
}

export default observer(UpgradePlan)
